export type Key =
  'LOGIN' |
  'ROOT' |
  'TOP' |
  'REPORT' |
  'REPORT_LIST' |
  'REPORT_DETAIL' |
  'REPORT_DETAIL_MONTHLY' |
  'REPORT_DETAIL_WEEKLY' |
  'REPORT_SEARCH' |
  'DATA_SUMMARY' |
  'ANALYZE' |
  'APP_ANALYZE' |
  'APP_ANALYZE_DETAIL' |
  'ANALYZE_REPORT' |
  'ANALYZE_REPORT_DETAIL' |
  'ANALYZE_SEARCH' |
  'EXPORT' |
  'DATA_SHEET_EXPORT' |
  'CSV_EXPORT' |
  'CSV_DOWNLOAD' |
  'DATA_SHEET_DOWNLOAD' |
  'EXPORT_COMPLETE' |
  'SEARCH' |
  'SETTING' |
  'SETTING_PERSONAL' |
  'SETTING_COMMON' |
  'SETTING_PROFILE' |
  'SETTING_MFA_AUTH' |
  'SETTING_MEMBER' |
  'SETTING_MEMBER_DETAIL' |
  'SETTING_TEAM' |
  'SETTING_COMPANY' |
  'SETTING_ADMIN' |
  'SETTING_IP_RESTRICTION' |
  'SETTING_OFFICE_IP_ADDRESS' |
  'SETTING_CUSTOM_ALERT' |
  'SETTING_IMPORT_CSV' |
  'SETTING_CLIENT_DOWNLOAD' |
  'SETTING_SLACK' |
  'SETTING_OAUTH' |
  'SETTING_MAIL_DELIVERY' |
  'SETTING_LANGUAGE' |
  'SETTING_MEASUREMENT' |
  'SETTING_WEB_BROWSER' |
  'SETTING_MEASUREMENT_RESTRICTION' |
  'SETTING_RECODE_API_CONNECT' |
  'SETTING_EXTERNAL_API_KEY' |
  'SETTING_HOLIDAY_SCHEDULE' |
  'SETTING_HOLIDAY' |
  'SETTING_BASE_WORK_TIME' |
  'SETTING_INDIVIDUAL_MEASUREMENT' |
  'GOOGLE_CALLBACK' |
  'LOGIN_GOOGLE_CALLBACK' |
  'LOGIN_GOOGLE_ZENDESK_CALLBACK' |
  'MICROSOFT_CALLBACK' |
  'LOGIN_MICROSOFT_CALLBACK' |
  'LOGIN_MICROSOFT_ZENDESK_CALLBACK' |
  'CYBOZU_CALLBACK' |
  'LOGIN_CYBOZU_CALLBACK' |
  'LOGIN_RESET_PASSWORD' |
  'RESET_PASSWORD' |
  'FREEE_CALLBACK' |
  'SLACK_CALLBACK' |
  'TUTORIAL_MASTER' |
  'TUTORIAL_MEMBER' |
  'PUBLIC_CLIENT_DOWNLOAD' |
  'WORK_STYLE' |
  'TASK' |
  'TASK_DETAIL_DETAIL' |
  'TASK_DETAIL' |
  'TASK_CATEGORY_DETAIL_DETAIL' |
  'TASK_CATEGORY_DETAIL' |
  'TASK_LABEL_ORDER_SETTING' |
  'TASK_LABELING_STATUS' |
  'TASK_LABEL_SETTING' |
  'TASK_LABEL_SETTING_DETAIL' |
  'TASK_LABEL_SETTING_CREATE' |
  'TASK_TARGET_SERVICE_SETTING' |
  'TASK_LABELING' |
  'TASK_LABELING_SELF' |
  'TASK_AUTO_LABELING' |
  'TASK_PROJECT_CATEGORY' |
  'TASK_MASTER' |
  'TASK_COST' |
  'TASK_PERMISSION' |
  'TASK_OTHER_SETTING' |
  'TASK_PROJECT_TEMPLATE_SETTING' |
  'TASK_PROJECT_TEMPLATE_SETTING_DETAIL' |
  'TASK_PROJECT_TEMPLATE_SETTING_CREATE' |
  'TASK_APPROVAL_SETTING' |
  'TASK_APPROVAL_STATUS' |
  'TASK_APPROVAL_STATUS_DETAIL' |
  'TASK_APPROVAL_SELF' |
  'TASK_BULK_LABELING' |
  'TASK_CSV_EXPORT' |
  'TASK_CSV_DOWNLOAD' |
  'TASK_THRESHOLD_TIME_SETTING' |
  'TASK_CREATE_MANUAL_TASK_ZONE_SETTING' |
  'TASK_CREATE_TASK_BY_URL_SETTING' |
  'TASK_LEARNING_SCOPE_SETTING' |
  'TASK_SEARCH' |
  'RISK' |
  'RISK_TIMELINE' |
  'RISK_MEMBER_LIST' |
  'RISK_MEMBER_DETAIL' |
  'RISK_TEAM_LIST' |
  'RISK_TEAM_DETAIL' |
  'RISK_CUSTOM_ALERT' |
  'GANTT_VIEW' |
  'CUSTOM_ALERT' |
  'SETTING_CONTRACT' |
  'SETTING_TASK_PERMISSION' |
  'SETTING_TASK_APPROVAL_SETTING' |
  'SETTING_TASK_EXCLUDE_GENERATE_MEMBER_SETTING' |
  'SETTING_TASK_THRESHOLD_TIME_SETTING' |
  'SETTING_TASK_CREATE_MANUAL_TASK_ZONE_SETTING' |
  'SETTING_TASK_CREATE_TASK_BY_URL_SETTING' |
  'SETTING_TASK_LEARNING_SCOPE_SETTING' |
  'SETTING_TASK_ONLINE_MEETING_SETTING' |
  'SETTING_ROLE'

type URL = {
  [key in Key]: {
    path: string
  }
}

export const URL: URL = {
  LOGIN: {
    path: '/',
  },
  ROOT: {
    path: '/',
  },
  TOP: {
    path: '/dashboard',
  },
  REPORT: {
    path: '/report',
  },
  REPORT_LIST: {
    path: '/report/:type',
  },
  REPORT_DETAIL: {
    path: '/report/:range/:target/:id',
  },
  REPORT_DETAIL_MONTHLY: {
    path: '/report/monthly/:target/:id',
  },
  REPORT_DETAIL_WEEKLY: {
    path: '/report/weekly/:target/:id',
  },
  REPORT_SEARCH: {
    path: '/report/search',
  },
  DATA_SUMMARY: {
    path: '/data_summary',
  },
  ANALYZE: {
    path: '/analyze',
  },
  APP_ANALYZE: {
    path: '/analyze/analyze_app',
  },
  APP_ANALYZE_DETAIL: {
    path: '/analyze/analyze_app/:name',
  },
  ANALYZE_REPORT: {
    path: '/analyze/analyze_report',
  },
  ANALYZE_REPORT_DETAIL: {
    path: '/analyze/analyze_report/:type',
  },
  ANALYZE_SEARCH: {
    path: '/analyze/search',
  },
  EXPORT: {
    path: '/export',
  },
  CSV_EXPORT: {
    path: '/export/csv',
  },
  DATA_SHEET_EXPORT: {
    path: '/export/data',
  },
  CSV_DOWNLOAD: {
    path: '/csv/download/:id',
  },
  DATA_SHEET_DOWNLOAD: {
    path: '/data/download/:id',
  },
  EXPORT_COMPLETE: {
    path: '/export/csv/complete',
  },
  SEARCH: {
    path: '/search',
  },
  SETTING: {
    path: '/setting',
  },
  SETTING_PERSONAL: {
    path: '/setting/personal',
  },
  SETTING_COMMON: {
    path: '/setting/common',
  },
  SETTING_PROFILE: {
    path: '/setting/profile',
  },
  SETTING_MFA_AUTH: {
    path: '/setting/mfa_auth',
  },
  SETTING_MEMBER: {
    path: '/setting/member',
  },
  SETTING_MEMBER_DETAIL: {
    path: '/setting/member/:id',
  },
  SETTING_TEAM: {
    path: '/setting/team',
  },
  SETTING_COMPANY: {
    path: '/setting/company',
  },
  SETTING_ADMIN: {
    path: '/setting/admin',
  },
  SETTING_IP_RESTRICTION: {
    path: '/setting/ip_restriction',
  },
  SETTING_OFFICE_IP_ADDRESS: {
    path: '/setting/office_ip_address',
  },
  SETTING_CUSTOM_ALERT: {
    path: '/setting/custom_alert',
  },
  SETTING_IMPORT_CSV: {
    path: '/setting/import/csv',
  },
  SETTING_CLIENT_DOWNLOAD: {
    path: '/setting/client_download',
  },
  SETTING_SLACK: {
    path: '/setting/slack',
  },
  SETTING_OAUTH: {
    path: '/setting/oauth',
  },
  SETTING_MAIL_DELIVERY: {
    path: '/setting/mail_delivery',
  },
  SETTING_LANGUAGE: {
    path: '/setting/language',
  },
  SETTING_MEASUREMENT: {
    path: '/setting/measurement',
  },
  SETTING_WEB_BROWSER: {
    path: '/setting/web_browser',
  },
  SETTING_MEASUREMENT_RESTRICTION: {
    path: '/setting/measure_restriction',
  },
  SETTING_RECODE_API_CONNECT: {
    path: '/setting/recode_api_connect',
  },
  SETTING_EXTERNAL_API_KEY: {
    path: '/setting/external_api_key',
  },
  SETTING_HOLIDAY_SCHEDULE: {
    path: '/setting/holiday_schedule',
  },
  SETTING_HOLIDAY: {
    path: '/setting/holiday',
  },
  SETTING_BASE_WORK_TIME: {
    path: '/setting/base_work_time',
  },
  SETTING_INDIVIDUAL_MEASUREMENT: {
    path: '/setting/individual_measurement',
  },
  SETTING_CONTRACT: {
    path: '/setting/contract',
  },
  SETTING_TASK_PERMISSION: {
    path: '/setting/t_permission',
  },
  SETTING_TASK_APPROVAL_SETTING: {
    path: '/setting/t_approval_setting',
  },
  SETTING_TASK_EXCLUDE_GENERATE_MEMBER_SETTING: {
    path: '/setting/t_exclude_generate_member_setting',
  },
  SETTING_TASK_THRESHOLD_TIME_SETTING: {
    path: '/setting/t_threshold_time_setting',
  },
  SETTING_TASK_CREATE_MANUAL_TASK_ZONE_SETTING: {
    path: '/setting/t_create_manual_task_zone_setting',
  },
  SETTING_TASK_CREATE_TASK_BY_URL_SETTING: {
    path: '/setting/t_create_task_by_url_setting',
  },
  SETTING_TASK_LEARNING_SCOPE_SETTING: {
    path: '/setting/t_learning_scope_setting',
  },
  SETTING_TASK_ONLINE_MEETING_SETTING: {
    path: '/setting/t_online_meeting_setting',
  },
  SETTING_ROLE: {
    path: '/setting/role',
  },
  GOOGLE_CALLBACK: {
    path: '/google/callback',
  },
  LOGIN_GOOGLE_CALLBACK: {
    path: '/login/google/callback',
  },
  LOGIN_GOOGLE_ZENDESK_CALLBACK: {
    path: '/login/google/zendesk/callback',
  },
  MICROSOFT_CALLBACK: {
    path: '/microsoft/callback',
  },
  LOGIN_MICROSOFT_CALLBACK: {
    path: '/login/microsoft/callback',
  },
  LOGIN_MICROSOFT_ZENDESK_CALLBACK: {
    path: '/login/microsoft/zendesk/callback',
  },
  CYBOZU_CALLBACK: {
    path: '/cybozu/callback',
  },
  LOGIN_CYBOZU_CALLBACK: {
    path: '/login/cybozu/callback',
  },
  LOGIN_RESET_PASSWORD: {
    path: '/login/reset_password',
  },
  RESET_PASSWORD: {
    path: '/reset_password',
  },
  FREEE_CALLBACK: {
    path: '/freee/callback',
  },
  SLACK_CALLBACK: {
    path: '/slackoauth',
  },
  TUTORIAL_MASTER: {
    path: '/tutorial_master',
  },
  TUTORIAL_MEMBER: {
    path: '/tutorial_member',
  },
  PUBLIC_CLIENT_DOWNLOAD: {
    path: '/download',
  },
  WORK_STYLE: {
    path: '/work_style',
  },
  TASK: {
    path: '/task',
  },
  TASK_DETAIL_DETAIL: {
    path: '/task/task_detail/:id',
  },
  TASK_DETAIL: {
    path: '/task/task_detail',
  },
  TASK_CATEGORY_DETAIL_DETAIL: {
    path: '/task/task_category_detail/:id',
  },
  TASK_CATEGORY_DETAIL: {
    path: '/task/task_category_detail',
  },
  TASK_LABEL_ORDER_SETTING: {
    path: '/task/task_label_order_setting',
  },
  TASK_LABELING_STATUS: {
    path: '/task/task_status',
  },
  TASK_LABEL_SETTING: {
    path: '/task/task_label_setting',
  },
  TASK_LABEL_SETTING_DETAIL: {
    path: '/task/task_label_setting/:id',
  },
  TASK_LABEL_SETTING_CREATE: {
    path: '/task/task_label_setting/create',
  },
  TASK_TARGET_SERVICE_SETTING: {
    path: '/task/task_target_service_setting',
  },
  TASK_LABELING: {
    path: '/task/task_status/:id',
  },
  TASK_LABELING_SELF: {
    path: '/task/task_labeling',
  },
  TASK_AUTO_LABELING: {
    path: '/task/task_auto_labeling',
  },
  TASK_PROJECT_CATEGORY: {
    path: '/task/task_project_category',
  },
  TASK_MASTER: {
    path: '/task/task_master',
  },
  TASK_COST: {
    path: '/task/task_cost',
  },
  TASK_PERMISSION: {
    path: '/task/task_permission',
  },
  TASK_OTHER_SETTING: {
    path: '/task/task_other_setting',
  },
  TASK_PROJECT_TEMPLATE_SETTING: {
    path: '/task/task_project_template_setting',
  },
  TASK_PROJECT_TEMPLATE_SETTING_DETAIL: {
    path: '/task/task_project_template_setting/:id',
  },
  TASK_PROJECT_TEMPLATE_SETTING_CREATE: {
    path: '/task/task_project_template_setting/create',
  },
  TASK_APPROVAL_SETTING: {
    path: '/task/task_approval_setting',
  },
  TASK_APPROVAL_STATUS: {
    path: '/task/task_approval_status',
  },
  TASK_APPROVAL_STATUS_DETAIL: {
    path: '/task/task_approval_status/:id',
  },
  TASK_APPROVAL_SELF: {
    path: '/task/task_application_approval',
  },
  TASK_BULK_LABELING: {
    path: '/task/task_bulk_status',
  },
  TASK_CSV_EXPORT: {
    path: '/task/csv_export',
  },
  TASK_CSV_DOWNLOAD: {
    path: '/task_csv/download/:id',
  },
  TASK_THRESHOLD_TIME_SETTING: {
    path: '/task/threshold_time_setting',
  },
  TASK_CREATE_MANUAL_TASK_ZONE_SETTING: {
    path: '/task/create_manual_task_zone_setting',
  },
  TASK_CREATE_TASK_BY_URL_SETTING: {
    path: '/task/create_task_by_url_setting',
  },
  TASK_LEARNING_SCOPE_SETTING: {
    path: '/task/learning_scope_setting',
  },
  TASK_SEARCH: {
    path: '/task/search',
  },
  RISK: {
    path: '/risk',
  },
  RISK_TIMELINE: {
    path: '/risk/timeline',
  },
  RISK_MEMBER_LIST: {
    path: '/risk/member_list',
  },
  RISK_MEMBER_DETAIL: {
    path: '/risk/member/:id',
  },
  RISK_TEAM_LIST: {
    path: '/risk/team_list',
  },
  RISK_TEAM_DETAIL: {
    path: '/risk/team/:id',
  },
  RISK_CUSTOM_ALERT: {
    path: '/risk/custom_alert',
  },
  GANTT_VIEW: {
    path: '/gantt_view',
  },
  CUSTOM_ALERT: {
    path: '/custom_alert',
  },
}
